module.exports = __webpack_public_path__ + "img/guide.51806a9a.png";